<template>
  <div @mousedown="windowActive(name)" v-show="globalVisible && visible" :style="styleObject" class="window">
    <div
      @mousedown       ="titleBarMousedownHandler"
      @touchstart.stop ="touchstart"
      class            ='title-bar'
    >
      <div class="title"><i class="el-icon-info"/> {{ name || 'window-ui' }}</div>
      <div class="title-bar-buttons">
        <button @mousedown.stop @click="toggleSize"><i class="el-icon-minus" /></button>
        <button @mousedown.stop @click="hide"><i class="el-icon-close" /></button>
      </div>
    </div>
    <slot v-if="!minimize" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'floatingWindow',
  data () {
    return {
      minimize   : false,
      mousedownX : 0,
      mousedownY : 0
    }
  },
  props    : [ 'name', 'width', 'height', 'top', 'left', 'defaultVisible' ],
  computed : {
    styleObject () {
      return {
        left       : this.getWindowData(this.name).left + 'px',
        top        : this.getWindowData(this.name).top + 'px',
        '--indexZ' : this.getWindowData(this.name).indexZ
      }
    },
    visible () {
      return this.getWindowData(this.name).visible
    },
    ...mapGetters('floatingWindow', [ 'globalVisible', 'getWindowData' ])
  },
  created () {
    this.name = this.name || 'UI Window'
    if (!this.getWindowData(this.name)) {
      this.addWindow({
        name    : this.name,
        top     : this.top || 100,
        left    : this.left || 100,
        visible : this.defaultVisible || false,
        indexZ  : 500
      })
    }
  },
  methods: {
    titleBarMousedownHandler (e) {
      this.mousedownX = e.offsetX
      this.mousedownY = e.offsetY
      window.addEventListener('mousemove', this.windowMousemoveHandler, false)
      window.addEventListener('mouseup', this.windowMouseupHandler, false)
    },
    windowMouseupHandler (e) {
      window.removeEventListener('mousemove', this.windowMousemoveHandler, false)
      window.removeEventListener('mouseup', this.windowMouseupHandler, false)
    },
    windowMousemoveHandler (e) {
      this.moveWindow({
        name : this.name,
        left : e.clientX - this.mousedownX,
        top  : e.clientY - this.mousedownY
      })
    },
    // <--- test touch
    touchstart (e) {
      console.log(e.changedTouches[0].target)
      if (e.type === 'touchstart') {
        const rect = e.changedTouches[0].target.getBoundingClientRect()
        this.mousedownX = e.changedTouches[0].pageX - rect.left
        this.mousedownY = e.changedTouches[0].pageY - rect.top
        window.addEventListener('touchmove', this.touchmove, false)
        window.addEventListener('touchend', this.touchend, false)
      }
    },
    touchmove (e) {
      if (e.type === 'touchmove') {
        e.stopPropagation()
        this.moveWindow({
          name : this.name,
          left : e.changedTouches[0].pageX - this.mousedownX,
          top  : e.changedTouches[0].pageY - this.mousedownY
        })
      }
    },
    touchend (e) {
      console.log(e)
      window.removeEventListener('touchmove', this.touchmove, false)
      window.removeEventListener('touchend', this.touchend, false)
    },
    // test touch --->
    toggleSize () {
      this.minimize = !this.minimize
    },
    hide () {
      this.toggleVisible(this.name)
    },
    ...mapMutations('floatingWindow', [
      'addWindow',
      'moveWindow',
      'toggleGlobalVisible',
      'toggleVisible',
      'windowActive'
    ])
  }
}
</script>

<style scoped>
.window {
  position         : fixed;
  z-index          : var(--indexZ);
  background-color : #dfe0d8;
  box-shadow       : 4px 4px 6px;
}
.title-bar {
  position         : relative;
  background-color : #23466e;
  color            : white;
  min-width        : 200px;
  width            : 100%;
  height           : 30px;
  user-select      : none;
}
.title {
  position     : absolute;
  top          : 50%;
  left         : 0%;
  transform    : translateY(-50%);
  padding-left : 6px;
}
.title-bar-buttons {
  position      : absolute;
  right         : 0px;
  top           : 50%;
  transform     : translateY(-50%);
  padding-right : 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/floatingWindow/index.vue